import { Routes } from '@angular/router';

import { AddressForm } from './components/address-form/address-form';
import { AddressMap } from './components/address-map/address-map';
import { LiveTracking } from './components/live-tracking/live-tracking';
import { Main } from './components/main/main';
import { TimeForm } from './components/time-form/time-form';

export const routes: Routes = [
  { path: '', component: Main },
  { path: 'main', component: Main },
  { path: 'map', component: AddressMap },
  { path: 'live-tracking', component: LiveTracking },
  { path: 'address-details', component: AddressForm },
  { path: 'time', component: TimeForm },
  { path: '**', component: Main },
];
